import React, { memo } from 'react';

import { Typography } from 'antd';

import ProfileItem from '../../../../components/ProfileItem/ProfileItem';
import {
  ITQServiceRequestDetails,
  TQServiceRequestTypeValue,
} from '../../../../types/tqConnectTypes/service-requests';
import { TQConnectUserAccessType } from '../../../../types/tqConnectTypes/user';

interface Props {
  userAccessType: TQConnectUserAccessType | null;
  serviceRequestDetails: ITQServiceRequestDetails;
  cameFrom: TQServiceRequestTypeValue;
  isMyRequest: boolean;
  canOfferHelp: boolean;
  canMarkAsCompleted: boolean;
  onGoBack: () => void;
}

const ServiceRequestDetailsHeader: React.FC<Props> = ({
  serviceRequestDetails,
}) => {
  const { title } = serviceRequestDetails;

  return (
    <div className="discover__page__content__header page__content__header">
      <ProfileItem
        className="header__item"
        title={
          <>
            <Typography.Title
              level={5}
              className="header__title"
              ellipsis={{ rows: 2, tooltip: true }}
              style={{ marginTop: 4, marginBottom: 0, fontSize: 20 }}>
              {title}
            </Typography.Title>
          </>
        }
        style={{
          alignItems: 'start',
        }}
        titleStyle={{
          fontSize: 20,
        }}
        contentStyle={{
          marginLeft: 0,
        }}
        actionStyle={{
          alignSelf: 'start',
        }}
      />
    </div>
  );
};

export default memo(ServiceRequestDetailsHeader);
